import * as React from 'react';
import { useSelector } from 'react-redux';

import { selectListingSeoData } from '../../../common/selectors/listingOffers';
import { SeoMarkedList } from '../../components';

export function SeoMarkedListContainer() {
  const seoData = useSelector(selectListingSeoData);

  if (!seoData.markedList?.items?.length) {
    return null;
  }

  return <SeoMarkedList items={seoData.markedList.items} />;
}
